class VideoBorderWithText extends HTMLElement {
    constructor() {
      super();
  
      this.videoWrapper = this.querySelector('.video-border-with-text__video-wrapper');
      if(this.videoWrapper) this.videoElement = this.videoWrapper.querySelector('video');
      this.playIcon = this.querySelector('.video-border-with-text__play-icon');
      this.pauseIcon = this.querySelector('.video-border-with-text__pause-icon');
      this.videoIcons = this.querySelector('.video-border-with-text__video-handle');
  
      this.videos = {
        mobile: {
          url: this.videoElement.dataset.videoUrl,
          poster: this.videoElement.dataset.poster
        },
        desktop: {
          url: this.videoElement.dataset.desktopVideoUrl,
          poster: this.videoElement.dataset.desktopPoster
        }
      }
  
      let mediaQueryList = window.matchMedia('(min-width: 600px)');
      mediaQueryList.matches ? this.updateVideo(this.videos.desktop) : this.updateVideo(this.videos.mobile);
  
      mediaQueryList.addEventListener('change', this.handleWindowResize.bind(this));

      if(this.playIcon) this.playIcon.addEventListener('click', this.videoPlay.bind(this));
      if(this.pauseIcon) this.pauseIcon.addEventListener('click', this.videoPause.bind(this));
      if(mediaQueryList.matches) {
        if(this.videoWrapper) this.videoWrapper.addEventListener('mouseover', this.showIcons.bind(this));
        if(this.videoWrapper) this.videoWrapper.addEventListener('mouseleave', this.hideIcons.bind(this));
      }

    }
  
    handleWindowResize(e) {
      e.matches ? this.updateVideo(this.videos.desktop) : this.updateVideo(this.videos.mobile);
    }
  
    updateVideo(newVideo) {
      this.videoElement.pause();
      
      let { url, poster } = newVideo;
      if (this.videoElement.src == url) return;
  
      this.videoElement.poster = poster;
      this.videoElement.src = url;
    }

    videoPlay() {
        this.playIcon.style.display = "none";
        this.pauseIcon.style.display = "block";
        this.videoElement.play();
    }

    videoPause() {
        this.pauseIcon.style.display = "none";
        this.playIcon.style.display = "block";
        this.videoElement.pause();
    }

    showIcons() {
        this.videoIcons.classList.add('active');
    }

    hideIcons() {
        this.videoIcons.classList.remove('active');
    }

  }
  
  customElements.define('video-border-with-text', VideoBorderWithText);